const watermark = {
  set(top_px, item, site) {
    var oTemp = document.createDocumentFragment();
    if (item.length > 0) {
      for (const i in item) {
        if (i % 2 === 0 && item.length > 5) {
          continue;
        }
        let top = null;
        item.length > 5 ? top = (Number(i) * top_px) : top = (Number(i) * 120);
        var mask_div = document.createElement('div');
        if (site) {
          mask_div.innerHTML = '<img src=' + site.logo + ' style="width:40px;height:40px;border-radius:50%;opacity:0.5;margin-right:10px;"' + ' /><span>' + site.name + '</span>';
        } else {
          mask_div.innerHTML = '';
        }
        mask_div.className = 'mask-div';
        mask_div.style.position = 'absolute';
        mask_div.style.top = top + 'px';
        mask_div.style.left = '0px';
        mask_div.style.right = '0px';
        mask_div.style.bottom = '0px';
        mask_div.style.margin = '0 auto';
        mask_div.style.overflow = 'hidden';
        mask_div.style.zIndex = '1';
        mask_div.style.opacity = '0.20';
        mask_div.style.fontSize = '20px';
        mask_div.style.fontFamily = '微软雅黑';
        mask_div.style.textAlign = 'center';
        mask_div.style.transform = 'rotate(-20deg)';
        mask_div.style.display = 'flex';
        mask_div.style.justifyContent = 'center';
        mask_div.style.alignItems = 'center';
        mask_div.style.width = '100%';
        mask_div.style.height = '60px';
        oTemp.appendChild(mask_div);
      }
    }
    return oTemp;
  }
};

export default watermark;
